module.exports = __webpack_public_path__ + "img/director-tiao-icon1.0cf946a2.png";